// extracted by mini-css-extract-plugin
export var md = "_5r-4";
export var semantic = "_5r-5";
export var sm = "_5r-3";
export var text = "_5r-6";
export var toggleInput = "_5r-0";
export var toggleSwitch = "_5r-1";
export var xs = "_5r-2";